<style scoped lang="scss">
  
</style>

<template>
  <div class="Show">
    <van-nav-bar
      title="我的优惠券"
      left-text=""
      left-arrow
      @click-left="$router.back(-1)"
    />
    <div class="cmain">
      <mycoupons :randomVal="Math.random()" v-on:immediateUse="immediateUse"></mycoupons>
    </div>
  </div>
</template>
<script>
import mycoupons from '@/views/m/components/myCoupons.vue'
export default {
    name: 'myCouponsList',
    components: {
      mycoupons
    },
    data() {
      return {
        
      }
    },
    mounted() {
      
    },
    methods: {
      immediateUse(data) {
        this.$router.push({ path: "/m" });
      }
    }
  }
</script>

